import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function post (path, data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/login/${path}`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, { cancelToken: source.token }).then((response) => response.data)
}

export default {
  fetchIndicators (data) {
    return post('indicators', data)
  },
  fetchDynamics (data) {
    return post('dynamics', data)
  },
}
